import { useState } from "react";
import MultiStep, { Steps } from "./multiStep";
import { Text } from "rizzui/typography";
import { ThemeSwitcher } from "../../component/themeSwitch";
import RingConnect from "../../assets/ringconnect";
import { ActionIcon } from "rizzui/action-icon";
import { useNavigate } from "react-router";
import CloseIcon from "../../assets/close";
import { ReactNode } from "react";
import cn from "../../lib/utils/class-name";

export interface PageInfo {
  title: string;
  subtitle: string;
  customStyle?: {
    headerTextContainerStyle?: React.CSSProperties | string;
    stepWidth?: string;
  };
}

export default function MultiStepLaout({
  multiStep,
  pageInfo,
  closeFunction,
  currentPage,
  children,
}: {
  multiStep: Steps[];
  pageInfo: PageInfo;
  closeFunction?: () => void;
  currentPage: string;
  children?: ReactNode;
}) {
  const navigate = useNavigate();
  return (
    <div>
      <div className="fixed z-[555] right-0 top-0">
        <ThemeSwitcher />
      </div>
      <div className="h-[70px] w-full flex items-center justify-between">
        <div
          className={cn(
            "w-[198px] flex-col gap-[4px] ml-[20px] xl:ml-[150px] mt-[13px] hidden sm:flex",
            pageInfo.customStyle?.headerTextContainerStyle
          )}
        >
          <Text className="font-ibmPlexSerif text-[16px] md:text-[18px] leading-[23.8px] font-[600] text-primary-dark">
            {pageInfo.title}
          </Text>
          <Text className="font-switzer text-[12px] md:text-[14px] leading-[18.48px] font-[400] text-[#758599]">
            {pageInfo.subtitle}
          </Text>
        </div>

        <div className="absolute w-full justify-center items-start flex">
          <RingConnect className={"w-[165px] h-[23px]"} />
        </div>

        <div className="absolute right-[48px] top-[10px]">
          <ActionIcon
            variant="text"
            className="bg-[#D1D6DD] size-[28px] rounded-full"
            onClick={() => {
              closeFunction ? closeFunction() : navigate("/dashboard");
            }}
          >
            <CloseIcon className={"size-[10px]"} />
          </ActionIcon>
        </div>
      </div>

      <div className="flex flex-col justify-start items-center xl:flex-row xl:justify-start xl:items-start w-full mt-[60px] h-fit gap-[204px]">
        <MultiStep data={multiStep} currentPage={currentPage} />
        <div className="absolute w-[96%] mx-auto md:w-full flex justify-center">
          {children}
        </div>
      </div>
    </div>
  );
}
